var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.25 12.1602H11.2305C11.277 12.1605 11.4582 12.2664 11.4951 12.3047C11.7567 12.5729 11.5672 12.9539 11.165 13L4.69043 12.9775C4.32283 12.8858 4.21738 12.4509 4.52246 12.2539C4.54432 12.24 4.70901 12.1614 4.72266 12.1602H5.7041V11.2393H10.25V12.1602ZM12.3516 3C13.1979 3.04782 13.8881 3.61007 13.9551 4.3291C14.0977 5.86843 13.8468 7.56461 13.9541 9.12012C13.8787 9.79251 13.2715 10.3359 12.4766 10.4238H3.47754C2.68373 10.3331 2.07464 9.79291 2 9.12012V4.30371C2.08961 3.62389 2.71268 3.08437 3.51855 3.00879L12.3516 3ZM4.69238 4.55371C4.22033 4.55371 3.77989 5.03023 3.74121 5.4082C3.65347 6.26892 3.80296 7.24132 3.75098 8.11328C3.74751 8.39249 4.29135 8.87012 4.59863 8.87012H7.44727V4.55371H4.69238ZM8.50586 8.87012H11.3545C11.6693 8.87012 12.2008 8.396 12.2031 8.11328C12.1511 7.24132 12.2997 6.26857 12.2119 5.4082C12.1732 5.02812 11.7411 4.55371 11.2607 4.55371H8.50586V8.87012Z",
    fill: "#524749"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabResult);
export default __webpack_public_path__ + "static/media/tab-result.61b262aeb2ec04536b712e137f185e6c.svg";
export { ForwardRef as ReactComponent };